const paths = {
  home: "/",
  register: "/register",
  login: "/sign-in",
  resetPassword: "/reset-password",
  cart: "/cart",
  checkout: "/checkout",
  wishList: "/wishlist",
  bundles: "/bundles",
  orderPlaced: "/order-placed",
  paymentFailed: "/payment-failed",
  paymentPending: "/payment-pending",
  processingTransaction: "/processing-transaction",
  products: "/products",
  newProduct: "/new-product",
  accountDeletionPending: "/account-deletion-pending",
  paymentDetails: "/payfort-payment/",
  account: {
    index: "/account",
    orders: {
      active: "/account/orders",
      inactive: "/account/orders/inactive",
      details: "/account/orders/details",
    },
    details: "/account/details",
    addresses: "/account/addresses",
    addressForm: "/account/addresses/address-form",
    locationPicker: "/account/addresses/location-picker",
    changePassword: "/account/change-password",
    paymentDetails: "/account/payment-details",
  },
  pages: {
    contactUs: "/contact-us",
    faq: "/FAQs",
    termsAndConditions: "/terms-and-conditions",
  },
};

export default paths;
